import { getDate, isSameDay, isSameMonth } from "date-fns";
import type { FC } from "react";
import { FlatRowDatePanelCell } from "web_myplann/Shared/Components/FlatRow/FlatRowDatePanelCell";
import { isDayWithinBounds } from "web_myplann/Shared/Components/FlatRow/isDayWithinBounds";

type Props = {
	days: Date[];
	month: Date;
	value: Date | null;
	minDate?: Date;
	maxDate?: Date;
	onSelect: (day: Date) => void;
};

export const FlatRowDateDayList: FC<Props> = ({
	days,
	month,
	value,
	minDate,
	maxDate,
	onSelect,
}) => (
	<>
		{days.map((day) => (
			<FlatRowDatePanelCell
				key={day.getTime()}
				label={String(getDate(day))}
				selected={value !== null && isSameDay(day, value)}
				outside={!isSameMonth(day, month)}
				disabled={!isDayWithinBounds(day, minDate, maxDate)}
				onClick={() => onSelect(day)}
			/>
		))}
	</>
);
